<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Actividades</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="dialogUpdateByDate = true">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn text small :disabled="loading" @click="dialogImport = true">
            Importar
            <v-icon right>mdi-arrow-up</v-icon>
          </v-btn>
          <download-csv v-show="false" ref="export" :data="export_data" name="actividades.csv"></download-csv>
          <v-btn text small :disabled="loading" @click="dialogExport = true">
            Exportar
            <v-icon right>mdi-arrow-down</v-icon>
          </v-btn>
          <v-btn text small :disabled="loading" @click="dialogRemoveByDate = true">
            Eliminar
            <v-icon right>mdi-delete-forever</v-icon>
          </v-btn>
          <v-btn text small :disabled="loading" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogFilters = true">
            Filtros
            <v-icon right>mdi-filter</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRemove = true">
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
        single-select show-select class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:item.password="{ item }">
            <v-btn v-if="item.password === ''" small rounded color="blue" dark>Disponible</v-btn>
            <v-btn v-else small rounded outlined color="blue-grey">No disponible</v-btn>
          </template>
          <template v-slot:item.encuesta="{ item }">
            {{ getName(item.encuesta, 'encuestas') }}
          </template>
          <template v-slot:item.relacion="{ item }">
            {{ getName(item.relacion, 'relaciones2') }}
          </template>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogFilters" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Filtros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="clearFilters()">
              Reiniciar
              <v-icon right>mdi-minus</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="closeFilters()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="setFilters()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.plaza" :items="plazas" item-value="id" item-text="nombre" label="Plaza" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.promotor" :items="promotores" item-value="id" item-text="nombre" label="Promotor" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.supervisor" :items="supervisores" item-value="id" item-text="nombre" label="Supervisor" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.nombre" label="Nombre" :rules="formRules.nombre" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.descripcion" label="Descripción" :rules="formRules.descripcion" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formNew.encuesta" :items="encuestas" item-value="id" item-text="nombre" label="Encuesta" :rules="formRules.encuesta" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formNew.relacion" :items="relaciones" item-value="id" item-text="nombre" label="Relación Tiendas/Empresas" :rules="formRules.relacion" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-dialog ref="NewStartDate" v-model="dialogNewStartDate" :return-value.sync="formNew.fecha_inicio" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formNew.fecha_inicio" label="Fecha inicio" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formNew.fecha_inicio" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogNewStartDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.NewStartDate.save(formNew.fecha_inicio)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-dialog ref="NewEndDate" v-model="dialogNewEndDate" :return-value.sync="formNew.fecha_fin" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formNew.fecha_fin" label="Fecha fin" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formNew.fecha_fin" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogNewEndDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.NewEndDate.save(formNew.fecha_fin)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.nombre" label="Nombre" :rules="formRules.nombre" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.descripcion" label="Descripción" :rules="formRules.descripcion" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formUpdate.encuesta" :items="encuestas" item-value="id" item-text="nombre" label="Encuesta" :rules="formRules.encuesta" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formUpdate.relacion" :items="relaciones" item-value="id" item-text="nombre" label="Relación Tiendas/Empresas" :rules="formRules.relacion" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-dialog ref="UpdateStartDate" v-model="dialogUpdateStartDate" :return-value.sync="formUpdate.fecha_inicio" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formUpdate.fecha_inicio" label="Fecha inicio" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formUpdate.fecha_inicio" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogUpdateStartDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.UpdateStartDate.save(formUpdate.fecha_inicio)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-dialog ref="UpdateEndDate" v-model="dialogUpdateEndDate" :return-value.sync="formUpdate.fecha_fin" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formUpdate.fecha_fin" label="Fecha fin" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formUpdate.fecha_fin" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogUpdateEndDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.UpdateEndDate.save(formUpdate.fecha_fin)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="remove()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateByDate" persistent max-width="850px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Modificar fechas y/o promotor de actividades masivamente</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updateByDate()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdateDate" lazy-validation>
                <v-row>
                  <v-col cols="6">
                    <v-dialog ref="UpdateStartDate" v-model="dialogUpdateStartDate" :return-value.sync="formUpdateDate.fecha_inicio" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="formUpdateDate.fecha_inicio" label="Nueva fecha de inicio" :rules="formRules.fecha_inicio" :disabled="loading" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formUpdateDate.fecha_inicio" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogUpdateStartDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.UpdateStartDate.save(formUpdateDate.fecha_inicio)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="6">
                    <v-dialog ref="UpdateEndDate" v-model="dialogUpdateEndDate" :return-value.sync="formUpdateDate.fecha_fin" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formUpdateDate.fecha_fin" label="Nueva fecha de fin" :rules="formRules.fecha_fin" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formUpdateDate.fecha_fin" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogUpdateEndDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.UpdateEndDate.save(formUpdateDate.fecha_fin)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete v-model="formUpdateDate.tipo" :items="tiposActualizacion" item-value="value" item-text="text" label="Tipo de actualización" :rules="formRules.tipo" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-file-input v-model="formUpdateDate.file.id" chips show-size label="Seleccionar archivo..." :disabled="loading"></v-file-input>
                  </v-col>
                  <v-col cols="12">
                  <v-switch v-model="formUpdateDate.file.header" label="Ignorar la primera fila" :disabled="loading"></v-switch>
                </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogImport" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Importar registros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelImport()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="acceptImport()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input v-model="importFile.id" chips show-size label="Actividades" :disabled="loading"></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-switch v-model="importFile.header" label="Ignorar la primera fila" :disabled="loading"></v-switch>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogExport" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Exportar actividades</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="exportData()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formExport" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-dialog ref="ExportStartDate" v-model="dialogExportStartDate" :return-value.sync="formExport.fecha_inicio" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formExport.fecha_inicio" label="Fecha inicio" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formExport.fecha_inicio" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogExportStartDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.ExportStartDate.save(formExport.fecha_inicio)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-dialog ref="ExportEndDate" v-model="dialogExportEndDate" :return-value.sync="formExport.fecha_fin" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="formExport.fecha_fin" label="Fecha fin" :disabled="loading" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="formExport.fecha_fin" locale="es" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dialogExportEndDate = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.ExportEndDate.save(formExport.fecha_fin)">Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemoveByDate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Eliminar actividades</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="removeByDate()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-dialog ref="RemoveDate" v-model="dialogRemoveDate" :return-value.sync="formRemove.fecha" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="formRemove.fecha" label="Fecha" :disabled="loading" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="formRemove.fecha" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogRemoveDate = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.RemoveDate.save(formRemove.fecha)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12">
                  <v-alert class="ma-2" border="left" elevation="2" dense colored-border type="warning">
                    Se eliminarán los registros hacia atrás a partir de la fecha seleccionada
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import Vue from 'vue'
import services from '@/utils/services'
import jsoncsv from 'vue-json-csv'

Vue.component('download-csv', jsoncsv)

export default {
  name: 'actividades',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    headers: [
      { text: 'Idexterno', align: 'center', sortable: false, value: 'idexterno' },
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Descripción', align: 'center', sortable: false, value: 'descripcion' },
      { text: 'Encuesta', align: 'center', sortable: false, value: 'encuesta' },
      { text: 'Tienda', align: 'center', sortable: false, value: 'tienda' },
      { text: 'Relación Tiendas/Empresas', align: 'center', sortable: false, value: 'relacion' },
      { text: 'Fecha inicio', align: 'center', sortable: false, value: 'fecha_inicio' },
      { text: 'Fecha fin', align: 'center', sortable: false, value: 'fecha_fin' },
      { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
    ],
    tiposActualizacion: [
      { text: 'ID Relación', value: 'idrelacion'},
      { text: 'ID Tienda', value: 'idtienda'},
      { text: 'ID Actividad', value: 'idactividad'},
    ],
    items: [],
    empresas: [],
    selected: [],
    encuestas: [],
    relaciones: [],
    relaciones2: [],
    plazas: [],
    promotores: [],
    supervisores: [],
    export_data: [],
    filters: {
      plaza: '',
      promotor: '',
      supervisor: ''
    },
    importFile: {
      id: null,
      header: false
    },
    dialogFilters: false,
    dialogNew: false,
    dialogUpdate: false,
    dialogRemove: false,
    dialogNewStartDate: false,
    dialogNewEndDate: false,
    dialogUpdateStartDate: false,
    dialogUpdateEndDate: false,
    dialogUpdateByDate: false,
    dialogImport: false,
    dialogExport: false,
    dialogExportStartDate: false,
    dialogExportEndDate: false,
    dialogRemoveByDate: false,
    dialogRemoveDate: false,
    formNew: {
      idexterno: '',
      nombre: '',
      descripcion: '',
      encuesta: '',
      relacion: '',
      fecha_inicio: '',
      fecha_fin: ''
    },
    formUpdate: {
      id: '',
      idexterno: '',
      nombre: '',
      descripcion: '',
      encuesta: '',
      relacion: '',
      fecha_inicio: '',
      fecha_fin: ''
    },
    formUpdateDate: {
      fecha_inicio: '',
      fecha_fin: '',
      tipo: '',
      file: {
        id: null,
        header: false
      }
    },
    formExport: {
      fecha_inicio: '',
      fecha_fin: ''
    },
    formRemove: {
      fecha: ''
    },
    formRules: {
      idexterno: [
        v => !!v || 'El idexterno es obligatorio',
        v => (v && v.length <= 50) || 'El idexterno excede la longitud máxima'
      ],
      nombre: [
        v => !!v || 'El nombre es obligatorio',
        v => (v && v.length <= 150) || 'El nombre excede la longitud máxima'
      ],
      descripcion: [
        v => !!v || 'La descripción es obligatoria',
        v => (v && v.length <= 150) || 'La descripción excede la longitud máxima'
      ],
      encuesta: [
        v => !!v || 'La encuesta es obligatoria'
      ],
      relacion: [
        v => !!v || 'La relación de tiendas/empresas es obligatoria'
      ],
      fecha_inicio: [
        v => !!v || 'La fecha inicio es obligatoria'
      ],
      fecha_fin: [
        v => !!v || 'La fecha fin es obligatoria'
      ],
      tipo: [
        v => !!v || 'El tipo de actualización es obligatorio'
      ],
    }
  }),
  mounted() {
    this.refresh()
    this.dialogFilters = true
  },
  methods: {
    refresh() {
      this.loading = true
      let data = {
        filtros: JSON.stringify(this.filters)
      }
      services.ws('get', 'actividades', data)
        .then(res => {
          if (res.ok) {
            this.items = res.data.actividades
            this.encuestas = res.data.encuestas
            this.relaciones = res.data.relaciones
            this.plazas = res.data.plazas
            this.supervisores = res.data.supervisores
            this.promotores = res.data.promotores
            this.relaciones2 = []
            let rels = []
            for (var i = 0; i < this.items.length; i++) {
              rels.push(this.items[i].relacion)
            }
            for (var i = 0; i < this.relaciones.length; i++) {
              if (rels.indexOf(this.relaciones[i].id) >= 0) {
                this.relaciones2.push(this.relaciones[i])
              }
            }
            this.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearFilters() {
      for (let key in this.filters) {
        this.filters[key] = ''
      }
    },
    closeFilters() {
      this.dialogFilters = false
    },
    setFilters() {
      if (this.filters.plaza !== '' || this.filters.promotor !== '' || this.filters.supervisor !== '') {
        this.loading = true
        let data = {
          filtros: JSON.stringify(this.filters)
        }
        services.ws('get', 'actividades', data)
          .then(res => {
            if (res.ok) {
              this.items = res.data.actividades
              this.encuestas = res.data.encuestas
              this.relaciones = res.data.relaciones
              this.plazas = res.data.plazas
              this.supervisores = res.data.supervisores
              this.promotores = res.data.promotores
              this.relaciones2 = []
              let rels = []
              for (var i = 0; i < this.items.length; i++) {
                rels.push(this.items[i].relacion)
              }
              for (var i = 0; i < this.relaciones.length; i++) {
                if (rels.indexOf(this.relaciones[i].id) >= 0) {
                  this.relaciones2.push(this.relaciones[i])
                }
              }
              this.selected = []
              this.closeFilters()
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'Debe establecer al menos un filtro'
      }
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset()
      }
      else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset()
      }
      else if (this.$refs.formUpdateDate) {
        this.$refs.formUpdateDate.reset()
      }
      else if (this.$refs.formExport) {
        this.$refs.formExport.reset()
      }
      else if (this.$refs.formRemove) {
        this.$refs.formRemove.reset()
      }
      for (let key in this.formNew) {
        this.formNew[key] = ''
      }
      for (let key in this.formUpdate) {
        this.formUpdate[key] = ''
      }
      for (let key in this.formUpdateDate) {
        if (key === 'file') {
          this.formUpdateDate[key] = {
            id: null,
            header: false
          }
        }
        else {
          this.formUpdateDate[key] = ''
        }
      }
      for (let key in this.formExport) {
        this.formExport[key] = ''
      }
      for (let key in this.formRemove) {
        this.formRemove[key] = ''
      }
    },
    cancel() {
      this.clear()
      this.selected = []
      this.newPassword = ''
      this.dialogNew = false
      this.dialogUpdate = false
      this.dialogPassword = false
      this.dialogRemove = false
      this.dialogNewStartDate = false
      this.dialogNewEndDate = false
      this.dialogUpdateStartDate = false
      this.dialogUpdateEndDate = false
      this.dialogUpdateByDate = false
      this.dialogExport = false
      this.dialogExportStartDate = false
      this.dialogExportEndDate = false
      this.dialogRemoveByDate = false
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'nuevaActividad', this.formNew)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]))
      this.dialogUpdate = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'actualizarActividad', this.formUpdate)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    remove() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'eliminarActividad', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    getName(id, key) {
      for (let i = 0; i < this[key].length; i++) {
        if (this[key][i].id == id) {
          return this[key][i].nombre
        }
      }
      return null
    },
    cancelImport() {
      this.importFile.id = null
      this.importFile.header = false
      this.dialogImport = false
    },
    acceptImport() {
      if (this.importFile.id) {
        let fr = new FileReader();
        let file = this.importFile.id
        let size = this.importFile.id.size
        if (size <= 10000000) {
          fr.onload = () => {
            this.loading = true
            let data = {
              file: fr.result,
              header: this.importFile.header
            }
            services.ws('post', 'importarActividades', data)
              .then(res => {
                if (res.ok) {
                  this.cancelImport()
                  this.cancel()
                  this.refresh()
                  this.success = true
                  this.msgSuccess = res.message
                }
                else {
                  this.error = true
                  this.msgError = res.message
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
          fr.onerror = () => {
            this.importFile.id = null
            this.error = true
            this.msgError = 'El archivo no fue leído correctamente'
          }
          fr.readAsDataURL(this.importFile.id);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (10 MB)'
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un archivo'
      }
    },
    exportData() {
      if (this.formExport.fecha_inicio !== '' && this.formExport.fecha_fin !== '') {
        this.loading = true
        let data = {
          filtros: JSON.stringify(this.formExport)
        }
        services.ws('get', 'totalActividades', data)
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.export_data = res.data.actividades
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.$refs.export.$el.click()
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un rango de fechas'
      }
    },
    removeByDate() {
      if (this.formRemove.fecha) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'eliminarActividadesPorFecha', { fecha: this.formRemove.fecha })
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'La fecha no ha sido seleccionada'
      }
    },
    updateByDate() {
      if (this.$refs.formUpdateDate.validate()) {
        if (this.formUpdateDate.file.id) {
          let fr = new FileReader();
          let file = this.formUpdateDate.file.id
          let size = this.formUpdateDate.file.id.size
          if (size <= 10000000) {
            fr.onload = () => {
              this.loading = true
              let data = JSON.parse(JSON.stringify(this.formUpdateDate))
              data.header = this.formUpdateDate.file.header
              data.file = fr.result
              setTimeout(() => {
                services.ws('post', 'actualizarFechasActividades', data)
                  .then(res => {
                    if (res.ok) {
                      this.cancel()
                      this.refresh()
                      this.success = true
                      this.msgSuccess = res.message
                    }
                    else {
                      this.error = true
                      this.msgError = res.message
                    }
                  })
                  .finally(() => {
                    this.loading = false
                  })
              }, 800)
            }
            fr.onerror = () => {
              this.formUpdateDate.file.id
              this.error = true
              this.msgError = 'El archivo no fue leído correctamente'
            }
            fr.readAsDataURL(this.formUpdateDate.file.id);
          }
          else {
            this.error = true
            this.msgError = 'El archivo ha excedido el límite permitido (10 MB)'
          }
        }
        else {
          this.error = true
          this.msgError = 'Debe seleccionar un archivo'
        }
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    }
  }
}
</script>
